import { Card, CardContent } from "@/components/ui/card";
import { UserX2, Building2 } from "lucide-react";

interface EmptyStateProps {
  showOrganizations: boolean;
}

export const EmptyState = ({ showOrganizations }: EmptyStateProps) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-8">
        {showOrganizations ? (
          <Building2 className="h-12 w-12 text-muted-foreground mb-4" />
        ) : (
          <UserX2 className="h-12 w-12 text-muted-foreground mb-4" />
        )}
        <h3 className="text-lg font-semibold mb-2">No results found</h3>
        <p className="text-muted-foreground text-center">
          {showOrganizations
            ? "No organizations match your search criteria"
            : "No artists match your search criteria"}
        </p>
      </CardContent>
    </Card>
  );
};